// Number / currency / percent formatters

export const fmtMoney = (n, opts = {}) => {
  const { compact = false, prefix = "$" } = opts;
  if (n === null || n === undefined || isNaN(n)) return `${prefix}0`;
  const v = Math.round(n);
  if (compact) {
    if (Math.abs(v) >= 1_000_000) return `${prefix}${(v / 1_000_000).toFixed(2)}M`;
    if (Math.abs(v) >= 10_000)   return `${prefix}${(v / 1_000).toFixed(0)}k`;
    if (Math.abs(v) >= 1_000)    return `${prefix}${(v / 1_000).toFixed(1)}k`;
  }
  return `${prefix}${v.toLocaleString("en-NZ")}`;
};

export const fmtPct = (n, digits = 0) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return `${(n * 100).toFixed(digits)}%`;
};

export const fmtPctCell = (n) => {
  if (n === 0 || n === null || n === undefined) return "";
  return `${Math.round(n * 100)}%`;
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-NZ", { day: "2-digit", month: "short", year: "numeric" });
};

const MONTH_SHORT_NAMES = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

// Contract-status display label. Stored value stays as "Yes"/"Tentative"/"No"
// so calc, filters and scenario helpers don't shift — this is display-only.
// Legacy "No" rows continue to display as "No" per spec.
export const contractLabel = (v) => (v === "Yes" ? "Confirmed" : v || "");

// Display number for a project — the editable `number` field (added Feb
// 2026) falls back to the internal `id` for projects that predate it.
export const projectNumber = (p) => (p && (p.number || p.id)) || "";

// Render a month key as "May 26". Accepts:
//  - "YYYY-MM"                → "Mmm YY"
//  - legacy bare name "May"   → "May" (fallback while any un-migrated data lingers)
export const fmtMonthShort = (key) => {
  if (!key) return "";
  const m = /^(\d{4})-(\d{2})$/.exec(String(key));
  if (m) {
    const y = m[1], mi = Number(m[2]) - 1;
    return `${MONTH_SHORT_NAMES[mi] || "?"} ${y.slice(-2)}`;
  }
  return String(key).slice(0, 3);
};
